import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const Container = ({ className = '', children }) => (
  <div className={`mx-auto w-full max-w-6xl px-5 md:px-8 ${className}`}>{children}</div>
);

export const Overline = ({ children, light = false, className = '' }) => (
  <p className={`text-[11px] font-semibold uppercase tracking-[0.28em] ${light ? 'text-tan' : 'text-moss-green'} ${className}`}>
    {children}
  </p>
);

export const SectionHeading = ({ overline, title, intro, light = false, as: H = 'h2' }) => (
  <div className="max-w-3xl">
    {overline && <Overline light={light}>{overline}</Overline>}
    <H className={`mt-4 font-serif font-medium leading-[1.1] ${H === 'h1' ? 'text-4xl md:text-[3.5rem]' : 'text-3xl md:text-[2.75rem]'} ${light ? 'text-bone-light' : 'text-kombu-green'}`}>
      {title}
    </H>
    {intro && <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? 'text-bone/85' : 'text-cafe-noir/80'}`}>{intro}</p>}
  </div>
);

const BTN = {
  primary: 'bg-kombu-green text-bone-light hover:bg-kombu-green-dark',
  secondary: 'border border-kombu-green/35 text-kombu-green hover:border-kombu-green hover:bg-kombu-green/5',
  light: 'bg-bone-light text-kombu-green hover:bg-white',
  ghostLight: 'border border-bone-light/40 text-bone-light hover:border-bone-light',
};

export const ButtonLink = ({ to, variant = 'primary', children, testId, className = '' }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-2 rounded-[2px] px-6 py-3.5 text-sm font-semibold tracking-wide transition-colors duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-moss-green ${BTN[variant]} ${className}`}
  >
    {children}
  </Link>
);

export const ArrowLink = ({ to, children, testId, light = false }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-2 text-sm font-semibold ${light ? 'text-tan hover:text-bone-light' : 'text-kombu-green hover:text-moss-green'} transition-colors`}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);

export const CheckList = ({ items, testId }) => (
  <ul className="divide-y divide-tan/40 border-y border-tan/40" data-testid={testId}>
    {items.map((item) => (
      <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-cafe-noir/90">
        <span className="mt-2.5 h-px w-4 flex-shrink-0 bg-moss-green" aria-hidden="true" />
        {item}
      </li>
    ))}
  </ul>
);
